import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { SortingDirection } from '../../modules/clientModule/components/Common/Table/types';
import { SchedulingType } from '../../api/scheduling';

export type VocabularyItem = {
  id: number;
  isActive: boolean;
  isDeleted: boolean;
  title: string;
  vocabularyEntity: number;
};
export interface GeneralState {
  vocabulary: VocabularyItem[];
  tableSortingDirection: SortingDirection;
  tableSortingKey: string;
  showDrawerContent: boolean;
  showNewProjectPopup: boolean;
  schedules: SchedulingType[];
  bottomDrawerOpened: boolean;
  allEmployees: any[]
  pulse: number;
  showTutorial: boolean;
  tableSelectAll: boolean;
  tableSelectedRows: any[]
  tableCheckAllClicked: boolean;
}

const initialState: GeneralState = {
  vocabulary: [],
  tableSortingDirection: 'NONE',
  tableSortingKey: '',
  showDrawerContent: false,
  showNewProjectPopup: false,
  schedules: [],
  bottomDrawerOpened: false,
  allEmployees: [],
  pulse: 0,
  showTutorial: false,
  tableSelectAll: false,
  tableSelectedRows: [],
  tableCheckAllClicked: false,
};

export const generalSlice = createSlice({
  name: 'general',
  initialState,
  reducers: {
    setVocabulary: (state, action: PayloadAction<any>) => {
      state.vocabulary = action.payload;
    },
    setTableSortingDirection: (state, action: PayloadAction<SortingDirection>) => {
      state.tableSortingDirection = action.payload;
    },
    setTableSortingKey: (state, action: PayloadAction<string>) => {
      state.tableSortingKey = action.payload;
    },
    setShowDrawerContent: (state, action: PayloadAction<boolean>) => {
      state.showDrawerContent = action.payload;
    },
    setShowNewProjectPopup: (state, action: PayloadAction<boolean>) => {
      state.showNewProjectPopup = action.payload;
    },
    setSchedules: (state, action: PayloadAction<SchedulingType[]>) => {
      state.schedules = action.payload;
    },
    setBottomDrawerOpened: (state, action: PayloadAction<boolean>) => {
      state.bottomDrawerOpened = action.payload;
    },
    setAllEmployees: (state, action: PayloadAction<any[]>) => {
      state.allEmployees = action.payload;
    },
    setPulse: (state, action: PayloadAction<number>) => {
      state.pulse = action.payload;
    },
    setShowTutorial: (state, action: PayloadAction<boolean>) => {
      state.showTutorial = action.payload;
    },
    setTableSelectAll: (state, action: PayloadAction<boolean>) => {
      state.tableSelectAll = action.payload;
    },
    setTableSelectedRows: (state, action: PayloadAction<any[]>) => {
      state.tableSelectedRows = action.payload;
    },
    setTableCheckAllClicked: (state, action: PayloadAction<boolean>) => {
      state.tableCheckAllClicked = action.payload;
    },
    resetGeneral: state => {
      state.vocabulary = [];
      state.tableSortingDirection = 'NONE';
      state.tableSortingKey = '';
      state.showDrawerContent = false;
      state.showNewProjectPopup = false;
      state.schedules = [];
      state.bottomDrawerOpened = false;
      state.allEmployees = [];
      state.pulse = 0;
      state.showTutorial = false;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setVocabulary,
  setTableSortingKey,
  setTableSortingDirection,
  setShowDrawerContent,
  setShowNewProjectPopup,
  setSchedules,
  setBottomDrawerOpened,
  resetGeneral,
  setAllEmployees,
  setPulse,
  setShowTutorial,
  setTableSelectAll,
  setTableSelectedRows,
  setTableCheckAllClicked,
} = generalSlice.actions;

export default generalSlice.reducer;
